/* cf-pdp v1 — petits comportements de la fiche produit.
   Chargé en module depuis les blocs et sections cf-pdp-* : exécuté une seule fois par page. */

const racine = document.documentElement;
racine.classList.add('cf-pdp-js');

/** Apparition douce des sections sous la fiche (fondu + léger glissement). */
function apparitions() {
  const cibles = Array.from(document.querySelectorAll('[data-cf-reveal]:not(.is-visible)'));
  if (cibles.length === 0) return;

  const toutMontrer = () => cibles.forEach((el) => el.classList.add('is-visible'));

  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    toutMontrer();
    return;
  }

  const observateur = new IntersectionObserver(
    (entrees) => {
      for (const entree of entrees) {
        if (!entree.isIntersecting) continue;
        entree.target.classList.add('is-visible');
        observateur.unobserve(entree.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
  );

  cibles.forEach((el) => observateur.observe(el));

  // Filet de sécurité : rien ne doit rester invisible.
  window.setTimeout(toutMontrer, 6000);
}

/** Section « Trois lumières » : l'intensité règle la clarté du miroir illustré. */
function lumieres(portee = document) {
  portee.querySelectorAll('[data-cf-lumieres]').forEach((boite) => {
    if (boite.dataset.cfLie === '1') return;
    boite.dataset.cfLie = '1';

    const curseur = boite.querySelector('[data-cf-intensite]');
    if (!(curseur instanceof HTMLInputElement)) return;

    const appliquer = () => boite.style.setProperty('--i', String(Number(curseur.value) / 100));
    curseur.addEventListener('input', appliquer);
    appliquer();
  });
}

/** Vente croisée : ajoute un siège au panier sans quitter la fiche. */
async function ajouterSiege(bouton) {
  const ligne = bouton.closest('.cf-pdp-croise__item');
  const champ = ligne?.querySelector('[data-cf-croise-var]');
  if (!champ || !champ.value || bouton.disabled) return;
  const libelle = bouton.dataset.cfLibelle || bouton.textContent;
  bouton.dataset.cfLibelle = libelle;
  bouton.disabled = true;
  const rendre = () => window.setTimeout(() => { bouton.textContent = libelle; bouton.disabled = false; }, 2500);
  let events = null;
  let envoi = null;
  try {
    events = await import('@shopify/events').catch(() => null);
    if (events && events.CartLinesUpdateEvent) {
      envoi = events.CartLinesUpdateEvent.createPromise();
      bouton.dispatchEvent(new events.CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: champ.value, quantity: 1 }],
        promise: envoi.promise,
      }));
    }
    const rep = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(champ.value), quantity: 1 }] }),
    });
    const donnees = await rep.json();
    if (!rep.ok || donnees.status) throw new Error(donnees.description || 'Ajout impossible');
    const panier = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    if (envoi && events) {
      envoi.resolve({
        cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(panier),
        detail: { items: panier.items, source: 'cf-pdp-croise', itemCount: 1, didError: false },
      });
    }
    bouton.textContent = 'Ajouté ✓';
  } catch (e) {
    if (envoi) envoi.reject(e);
    bouton.textContent = 'Indisponible';
  }
  rendre();
}

document.addEventListener('click', (e) => {
  const b = e.target instanceof Element ? e.target.closest('[data-cf-croise-add]') : null;
  if (b) ajouterSiege(b);
});

document.addEventListener('change', (e) => {
  const s = e.target;
  if (!(s instanceof HTMLSelectElement) || !s.matches('[data-cf-croise-var]')) return;
  const prix = s.selectedOptions[0]?.dataset.prix;
  const cible = s.closest('.cf-pdp-croise__item')?.querySelector('[data-cf-croise-prix]');
  if (prix && cible) cible.textContent = prix;
});

function initialiser() {
  apparitions();
  lumieres();
}

initialiser();

// Éditeur de thème : une section ajoutée ou rechargée est réinitialisée.
document.addEventListener('shopify:section:load', initialiser);
